import { render, staticRenderFns } from "./realTimePage.vue?vue&type=template&id=0478b021&"
import script from "./realTimePage.vue?vue&type=script&lang=js&"
export * from "./realTimePage.vue?vue&type=script&lang=js&"
import style0 from "./realTimePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports